import React from 'react'
import { render, RenderOptions } from 'storyblok-rich-text-react-renderer'
import { RichTextFieldProps } from '@/components/organisms/RichTextField/types'
import { blokResolvers, nodeResolvers, markResolvers } from './resolvers'

export function RichTextField({ data }: RichTextFieldProps) {
  if (!data) return null
  const elements: any = { ...data }
  elements.content.forEach((element: any, index: number) => {
    if (element.type === 'blok' && element?.attrs?.body[0]?.component === 'component_link') {
      if (elements.content[index - 1]?.type === 'paragraph') elements.content[index - 1].type = 'preceding_paragraph'
      if (elements.content[index + 1]?.type === 'paragraph') elements.content[index + 1].type = 'following_paragraph'
    } else if (
      (element.type === 'paragraph' || element.type === 'heading') &&
      element?.content &&
      element?.content[0]?.type === 'image'
    ) {
      if (index < 5) {
        // eslint-disable-next-line no-param-reassign
        element.content[0].attrs.loading = 'eager'
      } else {
        // eslint-disable-next-line no-param-reassign
        element.content[0].attrs.loading = 'lazy'
      }
    }
  })

  const options: RenderOptions = {
    blokResolvers,
    nodeResolvers,
    markResolvers
  }

  return <>{render(elements, options)}</>
}
